import { ToastContainerProps } from "react-toastify";

import theme from "./theme";

export const toastifyConfig: ToastContainerProps = {
    theme: "colored",
    style: {
        "--toastify-text-color-dark": theme.palette.success.contrastText,
        "--toastify-color-success": theme.palette.success.main,
        "--toastify-text-color-success": theme.palette.success.contrastText,
    } as React.CSSProperties,
    // Toastify__close-button: "",
};
